import styled from 'styled-components';
import { layout } from 'tokens';

interface BaseProps {
	makeSpaceForSidebar: boolean;
}

export const Base = styled.div<BaseProps>`
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	box-sizing: border-box;
	height: ${layout.inspectorNavbarHeight}px;
	--navbar-height: ${layout.inspectorNavbarHeight}px;
	background: ${({ theme }) => theme.gray[0]};
	gap: 0px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	padding-left: ${({ makeSpaceForSidebar }) =>
		makeSpaceForSidebar ? layout.sidebarToggleWidth : 6}px;
`;
